import React from "react";
import PropTypes from "prop-types";
import DependantRecord from "./DependantRecord";

const Dependent = ({ data }) => (
  <fieldset>
    <h3>DEPENDANT(S) PARTICULARS - (to complete only if spouse/children are covered)</h3>
    <table>
      <thead>
        <tr>
          <td>Relationship</td>
          <td>
            Name <span>(Full name as shown in NRIC/Passport)</span>
          </td>
          <td>NRIC/Passport No.</td>
          <td>Nationality</td>
          <td>Occupation</td>
          <td>Gender (M/F)</td>
          <td>Date of Birth (YYYY-MM-DD)</td>
          <td>Height (cm)</td>
          <td>Weight (kg)</td>
        </tr>
      </thead>
      <tbody>
        <DependantRecord
          {...{
            fieldNamePrefix: "Spouse",
            relationship: "Spouse",
            data,
          }}
        />
        <DependantRecord
          {...{
            fieldNamePrefix: "FirstChild",
            relationship: (
              <span>
                1<sup>st</sup> Child
              </span>
            ),
            data,
          }}
        />
        <DependantRecord
          {...{
            fieldNamePrefix: "SecondChild",
            relationship: (
              <span>
                2<sup>nd</sup> Child
              </span>
            ),
            data,
          }}
        />
        <DependantRecord
          {...{
            fieldNamePrefix: "ThirdChild",
            relationship: (
              <span>
                3<sup>rd</sup> Child
              </span>
            ),
            data,
          }}
        />
      </tbody>
    </table>
  </fieldset>
);

Dependent.propTypes = {
  data: PropTypes.object,
};

export default Dependent;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/Dependent.jsx